import { markRaw } from 'vue';

import { RocketLaunchIcon } from '@heroicons/vue/20/solid';
import { EnvelopeIcon } from '@heroicons/vue/24/outline';
import ResumeAiIcon from '../icons/tools/resume-icon.vue';
import JobTrakerIcon from '../icons/tools/interview-ai-icon.vue';
import CoverLetterIcon from '../icons/tools/cover-letter-tool.vue';
import NetworkAiIcon from '../icons/tools/network-icon.vue';
import JobTrackerAiIcon from '../icons/tools/job-tracker-icon.vue';
import JobBoardAiIcon from '../icons/tools/job-board-ai-icon.vue';
import BulletListIcon from '../icons/bullet-list-icon.vue';
import LearningHubIcon from '../icons/learning-hub.vue';

export const BASIC_FEATURES = [
	{
		description: 'High level resume score',
		icon: markRaw(ResumeAiIcon)
	},
	{
		description: 'Access to resume builder',
		icon: markRaw(ResumeAiIcon)
	},
	{
		description: '3 resume upload',
		icon: markRaw(ResumeAiIcon)
	},
	{
		description: '5 bullet point generations',
		icon: markRaw(BulletListIcon)
	},
	{
		description: '3 cover letter generation',
		icon: markRaw(CoverLetterIcon)
	},
	{
		description: '1 networking message',
		icon: markRaw(NetworkAiIcon)
	},
	{
		description: '30 tracked job applications',
		icon: markRaw(JobTrackerAiIcon)
	},
	{
		description: '1 InterviewAI training',
		icon: markRaw(JobTrakerIcon)
	},
	{
		description: 'Access to JobBoardAI',
		icon: markRaw(JobBoardAiIcon)
	},
	{
		description: 'Limited Learning Hub course access',
		icon: markRaw(LearningHubIcon)
	},
	{
		description: 'Unlimited resume downloads',
		icon: markRaw(ResumeAiIcon)
	},
	{
		description: '3 company email searches',
		icon: markRaw(NetworkAiIcon)
	},
	{
		description: '3 networking messages',
		icon: markRaw(NetworkAiIcon)
	},
	{
		description: '3 cold email generations',
		icon: markRaw(JobTrakerIcon)
	},
	{
		description: '50 tracked jobs',
		icon: markRaw(JobTrackerAiIcon)
	},
	{
		description: '3 company email searches',
		icon: markRaw(EnvelopeIcon)
	},
	{
		description: '3 cold email generations',
		icon: markRaw(EnvelopeIcon)
	},
];

export const PREMIUM_FEATURES = [
	{
		description: 'Complete resume score and breakdown',
		icon: markRaw(ResumeAiIcon)
	},
	{
		description: 'Specific improvement recommendations',
		icon: markRaw(ResumeAiIcon)
	}, 
	{
		description: 'Unlimited resume uploads',
		icon: markRaw(ResumeAiIcon)
	},
	{
		description: 'Unlimited AI-powered bullet points',
		icon: markRaw(BulletListIcon)
	},
	{
		description: 'Unlimited cover letter generation',
		icon: markRaw(CoverLetterIcon)
	},
	{
		description: 'Unlimited networking messages',
		icon: markRaw(NetworkAiIcon)
	},
	{
		description: 'Unlimited tracked job applications',
		icon: markRaw(JobTrackerAiIcon)
	},
	{
		description: 'Unlimited InterviewAI training',
		icon: markRaw(JobTrakerIcon)
	},
	{
		description: 'Unlimited Learning Hub course access',
		icon: RocketLaunchIcon
	},
	{
		description: 'Unlimited WonsultingAI access',
		icon: RocketLaunchIcon
	},
	{
		description: 'Unlimited bullet point generations',
		icon: markRaw(BulletListIcon)
	},
	{
		description: 'Role specific achievement language',
		icon: markRaw(BulletListIcon)
	},
	{
		description: 'Unlimited company email searches',
		icon: markRaw(NetworkAiIcon)
	},
	{
		description: 'Unlimited cold email generation',
		icon: markRaw(JobTrakerIcon)
	},
	{
		description: 'Unlimited tracked jobs',
		icon: markRaw(JobTrackerAiIcon)
	},
	{
		description: 'Role-specific practice sessions',
		icon: markRaw(JobTrakerIcon)
	},
	{
		description: 'Multiple interviewer personalities',
		icon: markRaw(NetworkAiIcon)
	},
	{
		description: 'Performance analytics & scoring',
		icon: markRaw(LearningHubIcon)
	},
	{
		description: 'Interview feedback and improvement tips',
		icon: markRaw(JobTrakerIcon)
	},
	{
		description: 'Sync unlimited emails automatically',
		icon: markRaw(EnvelopeIcon)
	},
	{
		description: 'Application status tracking',
		icon: markRaw(JobTrackerAiIcon)
	},
	{
		description: 'Interview and offer rate analytics',
		icon: markRaw(JobTrackerAiIcon)
	},
	{
		description: 'Unlimited company email searches',
		icon: markRaw(EnvelopeIcon)
	},
	{
		description: 'Unlimited cold email generation',
		icon: markRaw(EnvelopeIcon)
	},
	{
		description: 'Access to JobBoardAI & AutoApply',
		icon: markRaw(JobBoardAiIcon)
	},
];
